export default "__VITE_ASSET__DNQLtQgP__"